import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Card } from '../ui/card';

const ProblemSolutionSection = () => {
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center mb-10">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#073A40] mb-4">
            Evite Dores de Cabeça e Multas
          </h2>
          <p className="text-xl sm:text-2xl text-[#06323B] font-medium">
            A Importância da Engenharia Legalizada
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
          <Card className="p-6 sm:p-8 border-2 border-red-100 bg-red-50/50 hover:shadow-xl transition-all duration-300">
            <div className="flex items-start space-x-4 mb-6">
              <div className="flex-shrink-0 w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center">
                <AlertTriangle className="text-red-600" size={28} />
              </div>
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-[#073A40] mb-3">
                  Os Riscos de Obras Irregulares
                </h3>
              </div>
            </div>
            <ul className="space-y-3">
              {[
                'Multas pesadas da fiscalização municipal',
                'Embargo da obra e paralisação do projeto',
                'Dificuldade para vender ou financiar o imóvel',
                'Riscos estruturais e de segurança',
                'Problemas com cartório e documentação',
                'Impossibilidade de obter Habite-se'
              ].map((risk, index) => (
                <li key={index} className="flex items-start space-x-3 text-[#06323B]">
                  <span className="text-red-600 mt-1 text-xl">✕</span>
                  <span className="text-base sm:text-lg">{risk}</span>
                </li>
              ))}
            </ul>
          </Card>

          <Card className="p-6 sm:p-8 border-2 border-[#A69076] bg-gradient-to-br from-[#073A40] to-[#06323B] hover:shadow-xl transition-all duration-300">
            <div className="flex items-start space-x-4 mb-6">
              <div className="flex-shrink-0 w-14 h-14 bg-[#A69076] rounded-lg flex items-center justify-center">
                <CheckCircle2 className="text-white" size={28} />
              </div>
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
                  Como Resolvo Seus Problemas
                </h3>
              </div>
            </div>
            <ul className="space-y-3">
              {[
                'Projetos aprovados conforme legislação vigente',
                'Acompanhamento técnico durante toda a obra',
                'Regularização completa do seu imóvel',
                'Garantia de segurança estrutural',
                'Documentação em ordem para cartório',
                'Habite-se e Averbação sem complicações'
              ].map((solution, index) => (
                <li key={index} className="flex items-start space-x-3 text-white">
                  <CheckCircle2 className="text-[#A69076] flex-shrink-0 mt-1" size={20} />
                  <span className="text-base sm:text-lg">{solution}</span>
                </li>
              ))}
            </ul>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
